import { render, staticRenderFns } from "./BasicShape.vue?vue&type=template&id=a1af6c58&"
import script from "./BasicShape.vue?vue&type=script&lang=js&"
export * from "./BasicShape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports